import { Component, Input, OnInit, Output, EventEmitter, SimpleChanges, ViewChild, OnChanges, ViewEncapsulation, ViewChildren, QueryList, ChangeDetectorRef } from '@angular/core';
import { Campaign3Service } from '../../services/campaign3.service';
import { Campaign3Info, MessageInstanceObject, JsonSchemaPianificazionePropertiesFormProperties, ArticoliDropdown, MessageInstanceRuleTypes, MessageInstanceObjectTypes, MessageInstanceRule, MessageInstanceRuleDetail, AccumulatorDetail_JACR_JAAR, AccumulatorDetail_JAAR, RegolaAvanzata, OperazioneAccumulatoriDropdown, ProductItemComplete, JsonSchemaEmissionePropertiesFormProperties, CalculateFruitionDateRequest, AccumulatorDetail_JACR } from '../../models/campaign-3.model';
import { FormFields } from '../../components/form-fields/form-fields.component';
import { CouponPianificazioneForm } from '../../models/campaign-3-planning.model';
import { QueryBuilderOption, TipoSogliaEmissioneDropdown } from '../../models/campaign-3-emission-conditions.model';
import { CalendarTranslateService } from 'app/modules/UIKit/services/calendarTranslate.service';
import { ConfirmationService, MessageService, SelectItem } from 'primeng/primeng';
import { TranslateService } from '@ngx-translate/core';
import { QueryBuilderConfig } from 'angular2-query-builder';
import { LoyaltyReasonService } from 'app/services/loyalty/reason.service';
import { Acm } from 'app/models/loyalty-acm.model';
import { AuthService } from 'app/services/user/auth.service';


@Component({
  selector: 'app-campaign-3-emission-conditions',
  templateUrl: './campaign-3-emission-conditions.component.html',
  styleUrls: ['./campaign-3-emission-conditions.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class Campaign3EmissionConditionsComponent implements OnInit {
  errorRules: boolean = false;



  handleSearch(queryResult: any) {
    console.log('Query inviata:', queryResult);
  }

  @Input() campaignInfo: Campaign3Info = null;
  @Input() ui_mode: string = this.srvCampaign3.ui_modes.CREATE;
  @Input() coupon_mode: string = this.srvCampaign3.coupon_modes.CREATE;
  @Input() formSchema: any;
  @Input() productList: Array<ProductItemComplete>;
  @Input() accumulatorList: Array<any>;
  @Input() miRuleTypesList: Array<MessageInstanceRuleTypes>;
  @Input() miObjectTypesList: Array<MessageInstanceObjectTypes>;
  @Input() readOnly: boolean = false;
  @Input() messageInstanceObject: MessageInstanceObject;
  @Input() language: string = "it";
  @Input() dateFormat: string = "dd/MM/yyyy";
  @Output() messageInstanceObjectChange: EventEmitter<MessageInstanceObject> = new EventEmitter<MessageInstanceObject>();
  @Output() anteprimaBarcodeChange: EventEmitter<string> = new EventEmitter<string>();




  @ViewChild('switchBarcodeAttivatore') switchBarcodeAttivatoreComponent: FormFields;


  //primi campi soglia
  @ViewChild('tipoSogliaEmissione') tipoSogliaEmissione: FormFields;
  @ViewChild('sogliaEmissione') sogliaEmissione: FormFields;
  @ViewChild('sogliaRiemissione') sogliaRiemissione: FormFields;
  @ViewChild('maxEmissioni') maxEmissioni: FormFields;

  //accumulatori
  @ViewChildren('acm_operation') acm_operation: QueryList<FormFields>;
  @ViewChildren('acm_value') acm_value: QueryList<FormFields>;
  @ViewChildren('acm_reaspm') acm_reaspm: QueryList<FormFields>;

  //accumulatori
  @ViewChildren('acm_rule_operator') acm_rule_operator: QueryList<FormFields>;
  @ViewChildren('acm_rule_value') acm_rule_value: QueryList<FormFields>;

  //articolo barcode
  @ViewChild('articoloCoupon') articoloCouponComponent: FormFields;
  @ViewChild('soloBarcode') soloBarcode: FormFields;
  @ViewChild('soloBarcodeText') soloBarcodeText: FormFields;
  @ViewChild('comboBarcodes') comboBarcodesComponent: FormFields;

  //articolo barcode attivatore
  @ViewChild('articoloCouponAttivatore') articoloCouponAttivatoreComponent: FormFields;
  @ViewChild('soloBarcodeAttivatore') soloBarcodeAttivatore: FormFields;
  @ViewChild('soloBarcodeAttivatoreText') soloBarcodeAttivatoreText: FormFields;
  @ViewChild('comboBarcodesAttivatore') comboBarcodesAttivatoreComponent: FormFields;

  //limiti di emissione
  @ViewChild('maxEmissioniTotali') maxEmissioniTotali: FormFields;
  @ViewChild('maxTransazioniCliente') maxTransazioniCliente: FormFields;
  @ViewChild('maxEmissioniClienteTransazioni') maxEmissioniClienteTransazioni: FormFields;


  @ViewChild('switchLimitiEmissione') switchLimitiEmissione: FormFields;
  @ViewChild('switchCouponRipetibile') switchCouponRipetibile: FormFields;


  @Input() getProductOnlyBarcodeReady;

  //comboTipoSogliaEmissione: Array<TipoSogliaEmissioneDropdown>;
  //comboOperazioniAccumulatori: Array<OperazioneAccumulatoriDropdown>;
  comboBarcodes: Array<{ id: string, barcode: string }> = [];
  comboBarcodesAttivatore: Array<{ id: string, barcode: string }> = [];

  barcodeAvailable = {
    articolo: true,
    articoloAttivatore: true
  }

  listAccumulatorModelEmission: Array<any> = [];
  listAccumulatorModelEmissionForRules: Array<any> = [];

  pianificazioneCouponForm: CouponPianificazioneForm = new CouponPianificazioneForm();

  valid: boolean = true;
  //listaAccumulatoriSelezionati: Array<any> = [];

  switch = {
    couponRipetibile: false,
    gestioneAccumulatori: false,
    emissioneBarcodeAttivatore: false,
    soloBarcode: false,
    soloBarcodeAttivatore: false,
    limitiEmissione: false
  }
  disabledSwitch = {
    couponRipetibile: false,
    gestioneAccumulatori: false
  }

  show = {
    form: false,
    modalAcmList: false,
    modalAcmListForRules: false,
    modalProductList: false,
    modalProductListAttivatore: false,
    comboArticoloCoupon: false,
    comboArticoloCouponAttivatore: false,
    mandatoryProduct: false
  }

  fieldModel = {
    tipoSogliaEmissione: null,
    sogliaEmissione: null,
    couponRipetibile: {
      sogliaRiemissione: null,
      maxEmissioni: null
    },
    gestioneAccumulatori: {
      accumulatoriDaUtilizzare: [],
      regoleAvanzate: [],
    },
    articoloCoupon: {
      articolo: null,
      barcode: null
    },
    barcodeManualCoupon: null,
    articoloCouponAttivatore: {
      articolo: null,
      barcode: null
    },
    barcodeManualCouponAttivatore: null,
    limitiEmissione: {
      maxEmissioniTotali: null,
      maxTransazioniCliente: null,
      maxEmissioniCliente: null
    }
  }

  //Coupon Info
  CV_rules: Array<MessageInstanceRule> = [];

  //Barcode Coupon Info
  BC_rules: Array<MessageInstanceRule> = [];

  //Barcode Activator Info
  BA_rules: Array<MessageInstanceRule> = [];

  //Accumulator
  AC_rules: Array<MessageInstanceRule> = [];

  //transaction emission fruition limits
  LM_rules: Array<MessageInstanceRule> = [];

  //queryParams
  accorditionOpen = false;


/* 
  query = {
    condition: 'OR',
    rules: [
      {
        field: 'accumulatore',
        operator: '>=',
        value: ''
      },

    ]
  };
  config: QueryBuilderConfig;
 */
  useAnd: boolean = true; // true = AND, false = OR



selectedMode: boolean = true; 
// true = Gestione Koncentro
// false = Gestione FE






  constructor(
    private srvCampaign3: Campaign3Service,
    private srvCalTranslate: CalendarTranslateService,
    private confirmationService: ConfirmationService,
    private translateService: TranslateService,
    private srvMessage: MessageService,
    private cdRef: ChangeDetectorRef,
    private svcReason: LoyaltyReasonService,
     private authService: AuthService,
  ) {

  }
  reasonItems: { value: string, label: string ,sign:string}[] = [];
@Input() isActionDynamic: boolean = false;



  queryOutput: string = '';



/*   buildQueryObjectsArray(): any[] {
    this.errorRules = false;
    let result: any[] = [];

    if (this.hasEmptyQueryRules()) {
      this.handleEmptyRulesError();
    } else if (this.hasInvalidRule()) {
      this.handleInvalidRulesError();
    } else {
      result = this.query.rules.map(rule => {
        const acm = rule.field === 'accumulatore' ? this.getAccumulatorById(rule.value) : undefined;

        return {
          check: [
            {
              condition: this.query.condition || 'AND',
              acm_code: acm ? String(acm.id) : String(rule.value),
              acm_type: 'emission',
              acm_points: 1,
              acm_operation: rule.operator
            }
          ]
        };
      });
    }

    return result;
  } */

  reconstructQueryFromString(jsonString: string): any {
    ;
    try {
      const parsed = JSON.parse(jsonString);

      const details = parsed.messageInstanceRuleDetail;
      const condition = parsed.condition || 'AND';

      if (!Array.isArray(details) || details.length === 0) {
        console.warn('Nessun dettaglio valido presente.');
        return null;
      }

      const rules: any[] = [];

      details.forEach((detail: any) => {
        if (!Array.isArray(detail.objectJson)) {
          console.warn('objectJson non è un array:', detail);
          return;
        }

        detail.objectJson.forEach((objJson: any) => {
          if (!objJson || !Array.isArray(objJson.check)) {
            console.warn('check non valido:', objJson);
            return;
          }

          objJson.check.forEach((check: any) => {
            if (!check.acm_code || !check.acm_operation) {
              console.warn('acm_code o acm_operation mancanti:', check);
              return;
            }

            rules.push({
              field: 'accumulatore',
              operator: check.acm_operation,
              value: check.acm_code
            });
          });
        });
      });

      return {
        condition,
        rules
      };
    } catch (e) {
      console.error('Errore durante il parsing della stringa JSON:', e);
      return null;
    }
  }




  // Cerca accumulatore per id
  getAccumulatorById(id: any): Acm | undefined {
    return this.listAccumulatorModelEmission.find(a => a.id == id);
  }


  ngAfterViewChecked() {

    this.cdRef.detectChanges();
  }
  ngOnInit() {

    console.log(this.formSchema.form.accumulatori_operazione);
    console.log(this.formSchema.form.switch_gestione_accumulatori);
    console.log(this.formSchema.form.accumulatori_regole_avanzate);
    console.log(this.formSchema.form.accumulatore_regole_operatore);
    this.listAccumulatorModelEmission = JSON.parse(JSON.stringify(this.accumulatorList));
    this.listAccumulatorModelEmissionForRules = JSON.parse(JSON.stringify(this.accumulatorList));

    // this.comboTipoSogliaEmissione = Object.assign([],this.formSchema.form.tipo_soglia_emissione.options);
    // this.comboOperazioniAccumulatori = Object.assign([],this.formSchema.form.accumulatore_operazione.options);
    console.log(this.formSchema);

    this.show.comboArticoloCouponAttivatore = true;
    this.show.comboArticoloCoupon = true;


    //TODO if per capire se esistono già regole e vadano valorizzate

    this.svcReason.listPointReason().subscribe(response => {
      this.reasonItems = response.data.map(r => ({
        label: r.description,   // quello che l’utente vede nel dropdown
        value: r.reason_code,
        sign : r.signDescription    // quello che viene salvato internamente
      }));



      this.show.form = true;
          var self = this;
    setTimeout(function () {

      //valorizzazione, caso edit

      if (self.messageInstanceObject.id) {
        self.getProductOnlyBarcodeReady = true;

      }

      if (self.messageInstanceObject && self.ui_mode == self.srvCampaign3.ui_modes.EDIT) {

        if (self.messageInstanceObject.couponType == self.srvCampaign3.couponType.RIPETIBILE) {
          self.switch.couponRipetibile = true;
        }
        else {
          self.switch.couponRipetibile = false;
        }

        if (self.messageInstanceObject.messageInstanceRule && self.messageInstanceObject.messageInstanceRule.length) {
          self.loadEmissionModel();
        }
      }
    }, 100);
    });



  }
  loadEmissionModel() {
    //ENNESIMO CAMBIAMENTI A SEGUITO DI KS-6304
    //maxEmissioniTotali nonostante è sotto i "limiti di emissione" non è una regola ma è il totalCouponNumber della message instance (cambiamento a seguito di call con Flavio)

    if (this.messageInstanceObject.totalCouponNumber) {
      this.switch.limitiEmissione = true;
      var self2 = this;
      setTimeout(function () {

        self2.fieldModel.limitiEmissione.maxEmissioniTotali = self2.messageInstanceObject.totalCouponNumber;
        self2.maxEmissioniTotali.fieldModel = self2.messageInstanceObject.totalCouponNumber;
      }, 100);
    }

    for (let mir of this.messageInstanceObject.messageInstanceRule) {

      if (mir.ruleScope == this.srvCampaign3.ruleScopesEmissionFruition.EMISSION) {
        if (mir.ruleTypeId == this.miRuleTypesList.find(x => x.code == "CV").id) {
          //ci sono regole CV
          for (let mird of mir.messageInstanceRuleDetail) {
       /*               if (mird.objectTypeId == self2.miObjectTypesList.find(x => x.code == "PTRT").id) {
              //this.fieldModel.tipoSogliaEmissione = this.comboTipoSogliaEmissione.find(x=>x.code == mird.objectValue);
              setTimeout(function () {
                if (self2.tipoSogliaEmissione && self2.tipoSogliaEmissione.options) {
                  const option = self2.tipoSogliaEmissione.options.find(function (x) {
                    return x.value == mird.objectValue;
                  });

                  if (option) {
                    self2.onChangeTipoSoglia(option);
                  } else {
                    console.warn('Option non trovata per tipoSogliaEmissione con value:', mird.objectValue);
                  }
                } else {
                  console.warn('tipoSogliaEmissione o le sue options non sono ancora inizializzate');
                }
              }, 200);

            } */
            if (mird.objectTypeId == this.miObjectTypesList.find(x => x.code == "PTRT").id) {
            
              this.onChangeTipoSoglia(this.tipoSogliaEmissione.options.find(x => x.value == mird.objectValue));
            } 
            if (mird.objectTypeId == this.miObjectTypesList.find(x => x.code == "PTRE").id) {
              this.fieldModel.sogliaEmissione = mird.objectValue ? +mird.objectValue / 100 : null;
            }
            //  if(mird.objectTypeId == this.miObjectTypesList.find(x=>x.code == "PRTR").id || mird.objectTypeId == this.miObjectTypesList.find(x=>x.code == "PMCN").id){
            if (mird.objectTypeId == this.miObjectTypesList.find(x => x.code == "PRTR").id) {

              //CONTROLLO: se il coupon non è ripetibile ma sono state definite soglie di emissione allora è un incongruenza di dati!
              if (this.messageInstanceObject.couponType != this.srvCampaign3.couponType.RIPETIBILE) {

                this.srvMessage.add({
                  severity: 'error',
                  summary: 'Error',
                  detail: this.translateService.instant('campaign.prtr_rule_exists_non_repeatable_coupon'),
                  life: 5000
                });


              }

              this.switch.couponRipetibile = true;
              var self2 = this;

              setTimeout(function () {
                if (mird.objectTypeId == self2.miObjectTypesList.find(x => x.code == "PRTR").id) {
                  self2.fieldModel.couponRipetibile.sogliaRiemissione = +mird.objectValue / 100;
                }
                /*
                if(mird.objectTypeId == self2.miObjectTypesList.find(x=>x.code == "PMCN").id){
                  self2.fieldModel.couponRipetibile.maxEmissioni = mird.objectValue;
                }
                */
              }, 100);
            }

          }
        }
        //LETTURA REGOLE E ACCUMULATORI TODO:testing
        if (
          mir.ruleScope === this.srvCampaign3.ruleScopesEmissionFruition.EMISSION &&
          mir.ruleTypeId === this.miRuleTypesList.find(x => x.code == 'AC').id
        ) {
          this.fieldModel.gestioneAccumulatori.accumulatoriDaUtilizzare = [];
          this.fieldModel.gestioneAccumulatori.regoleAvanzate = [];
     
          let self = this;
          setTimeout(function () {


            // --- JACR ---
            const jacrDetail = mir.messageInstanceRuleDetail.find(d => d.objectTypeCode === 'JACR');
            if (
              jacrDetail &&
              jacrDetail.objectJson &&
              Array.isArray(jacrDetail.objectJson.check)
            ) {
              const checks = jacrDetail.objectJson.check as AccumulatorDetail_JACR_JAAR[];
              if (checks.length > 0) {
                self.useAnd = (checks[0].operator === 'AND');
                self.selectedMode =(checks[0].koncentro === true);
              }
              for (let check of checks) {
                // Recupero l'accumulatore originale
                let originalRule = self.listAccumulatorModelEmission.find(x => x.id == check.acm_id);

                if (!originalRule) {
                  console.warn('Accumulatore non trovato per id:', check.acm_id);
                  continue;
                }

                // Clono l'oggetto per evitare riferimenti condivisi
                let loadedAccumulatorRules = JSON.parse(JSON.stringify(originalRule));

                // Recupero l'operatore corretto
                let optionFound = self.formSchema.form.accumulatore_regole_operatore.options.find(
                  function (x) {
                    return x.value == check.acm_operation;
                  }
                );
                if (!optionFound) {
                  console.warn('Operatore non trovato per value:', check.acm_operation);
                  continue;
                }

                loadedAccumulatorRules.c3AcmRuleOperator = {
                  label: optionFound.label[self.authService.sessionHelper.selectedLanguage],
                  value: optionFound.value
                };
                loadedAccumulatorRules.c3AcmRuleValue = check.acm_points;
                loadedAccumulatorRules.acm_code = check.acm_code;

                self.fieldModel.gestioneAccumulatori.regoleAvanzate.push(loadedAccumulatorRules);
              }
            }

                      // --- JAAR ---
          const jaarDetail = mir.messageInstanceRuleDetail.find(d => d.objectTypeCode === 'JAAR');
          if (
            jaarDetail &&
            jaarDetail.objectJson &&
            Array.isArray(jaarDetail.objectJson.move)
          ) {
            const moves = jaarDetail.objectJson.move as AccumulatorDetail_JACR_JAAR[];
  if (moves.length > 0) {
                self.useAnd = (moves[0].operator === 'AND');
                self.selectedMode =(moves[0].koncentro === true);
              }
              let i = 0
              
              for (let move of moves) {
                console.log(move);
                console.log(self.formSchema.form);
                //recupero l'accumulatore
                let loadedAccumulator = self.listAccumulatorModelEmission.find(x => x.id == move.acm_id);
                loadedAccumulator.c3AcmReason = self.reasonItems.find(x => x.value == move.acm_reason_code);
                let options = self.acm_operation.toArray()[i];
                /* loadedAccumulator.c3AcmOperation= self.formSchema.form.accumulatore_operazione.options.find(x => x.value== move.acm_operation).value; */
                let optionFound = self.formSchema.form.accumulatore_operazione.options.find(x => x.value == move.acm_operation);
                loadedAccumulator.c3AcmOperation = { label: optionFound.label[self.authService.sessionHelper.selectedLanguage], value: optionFound.value }
                loadedAccumulator.c3AcmValue = move.acm_points;
                loadedAccumulator.acm_code = move.acm_code;
                self.fieldModel.gestioneAccumulatori.accumulatoriDaUtilizzare.push(
                  loadedAccumulator
                );
                i++
              }
            }


          }, 500)
          this.switch.gestioneAccumulatori = true;
        

        }





        if (mir.ruleTypeId == this.miRuleTypesList.find(x => x.code == "BC").id) {

          let tbcd = mir.messageInstanceRuleDetail.find(x => x.objectTypeId == this.miObjectTypesList.find(x => x.code == "TBCD").id);
          let pbcd = mir.messageInstanceRuleDetail.find(x => x.objectTypeId == this.miObjectTypesList.find(x => x.code == "PBCD").id);

          //ci sono regole BC
          if (tbcd && tbcd.objectId) {
            this.switch.soloBarcode = false;

            var self2 = this;
            setTimeout(function () {

              self2.articoloCouponComponent.disabled = self2.readOnly ? self2.readOnly : self2.articoloCouponComponent.fieldSchema.disabled;
              let search = [
                { key: "id", value: tbcd.objectId.toString() }
              ];
              var self3 = self2;
              self2.srvCampaign3.getProductItemComplete(null, null, search).subscribe(res => {
                if (res && res.data && res.data.length > 0) {
                  let groupedData = self3.groupResults(res, "id", "barcode", "barcodes");
                  if (groupedData && groupedData.length > 0) {

                    self3.articoloCouponComponent.options = groupedData;
                    //TODO: convinto che ci sia un errore in visualizzazione dis to campo non capisco perchè barcode viene trattato come array
                    self3.fieldModel.articoloCoupon.articolo = groupedData[0];

                    self3.articoloCouponComponent.fieldModel = groupedData[0];

                  }
                  self3.comboBarcodes = [];
                  if (self3.fieldModel.articoloCoupon.articolo) {
                    for (let barcode of self3.fieldModel.articoloCoupon.articolo.barcodes) {
                      self3.comboBarcodes.push({ id: barcode, barcode: barcode });
                    }
                    self3.comboBarcodesComponent.options = self3.comboBarcodes;
                    self3.fieldModel.articoloCoupon.barcode = self3.comboBarcodesComponent.options.find(x => x.barcode == tbcd.objectValue);
                    if (self3.fieldModel.articoloCoupon.barcode) {
                      self3.anteprimaBarcodeChange.emit(self3.fieldModel.articoloCoupon.barcode);
                    }

                  }
                }
              });

            }, 100);

          }
          else if (pbcd) {
            this.switch.soloBarcode = true;

            var self2 = this;
            setTimeout(function () {
              self2.articoloCouponComponent.disabled = true;
              self2.fieldModel.barcodeManualCoupon = mir.messageInstanceRuleDetail.find(x => x.objectTypeId == self2.miObjectTypesList.find(x => x.code == "PBCD").id).objectValue;
              self2.anteprimaBarcodeChange.emit(self2.fieldModel.barcodeManualCoupon);
            }, 100);
          }

        }

        if (mir.ruleTypeId == this.miRuleTypesList.find(x => x.code == "BA").id) {
          this.switch.emissioneBarcodeAttivatore = true;
          //ci sono regole BA
          let tbcd = mir.messageInstanceRuleDetail.find(x => x.objectTypeId == this.miObjectTypesList.find(x => x.code == "TBCD").id);
          let pbcd = mir.messageInstanceRuleDetail.find(x => x.objectTypeId == this.miObjectTypesList.find(x => x.code == "PBCD").id);

          if (tbcd && tbcd.objectId) {
            this.switch.soloBarcodeAttivatore = false;
            var self2 = this;

            setTimeout(function () {
              //self2.articoloCouponAttivatoreComponent.disabled = false;
              self2.articoloCouponAttivatoreComponent.disabled = self2.readOnly ? self2.readOnly : self2.articoloCouponAttivatoreComponent.fieldSchema.disabled;

              let search = [
                { key: "id", value: tbcd.objectId.toString() }
              ];
              var self3 = self2;
              self2.srvCampaign3.getProductItemComplete(null, null, search).subscribe(res => {

                if (res && res.data && res.data.length > 0) {
                  let groupedData = self3.groupResults(res, "id", "barcode", "barcodes");
                  if (groupedData && groupedData.length > 0) {
                    self3.fieldModel.articoloCouponAttivatore.articolo = groupedData[0];
                    self3.articoloCouponAttivatoreComponent.options = groupedData;
                    self3.articoloCouponAttivatoreComponent.fieldModel = groupedData[0];
                  }
                  self3.comboBarcodesAttivatore = [];
                  if (self3.fieldModel.articoloCouponAttivatore.articolo) {
                    for (let barcode of self3.fieldModel.articoloCouponAttivatore.articolo.barcodes) {
                      self3.comboBarcodesAttivatore.push({ id: barcode, barcode: barcode });
                    }
                    self3.comboBarcodesAttivatoreComponent.options = self3.comboBarcodesAttivatore;
                    self3.fieldModel.articoloCouponAttivatore.barcode = self3.comboBarcodesAttivatoreComponent.options.find(x => x.barcode == tbcd.objectValue);
                  }
                }

              });

            }, 100);
          }
          else if (pbcd) {
            this.switch.soloBarcodeAttivatore = true;
            var self2 = this;
            setTimeout(function () {
              self2.articoloCouponAttivatoreComponent.disabled = true;
              self2.fieldModel.barcodeManualCouponAttivatore = mir.messageInstanceRuleDetail.find(x => x.objectTypeId == self2.miObjectTypesList.find(x => x.code == "PBCD").id).objectValue;
            }, 100);
          }
        }

        if (mir.ruleTypeId == this.miRuleTypesList.find(x => x.code == "LM").id) {
          for (let mird of mir.messageInstanceRuleDetail) {

            /*** MODIFICA KS-6304: non è più una regola, ma è la proprietà totalCouponNumber dell'oggettone della messageInstance */
            /*
            if(mird.objectTypeId == this.miObjectTypesList.find(x=>x.code == "PMNC").id){
              this.fieldModel.limitiEmissione.maxEmissioniTotali = mird.objectValue;
            }
            */
            if (mird.objectTypeId == this.miObjectTypesList.find(x => x.code == "PMTC").id) {
              this.switch.limitiEmissione = true;
              this.fieldModel.limitiEmissione.maxTransazioniCliente = mird.objectValue;
            }
            if (mird.objectTypeId == this.miObjectTypesList.find(x => x.code == "PMCT").id) {
              //questa è una regola dei limiti ma è sotto lo switch couponRipetibile
              this.switch.couponRipetibile = true;
              this.fieldModel.couponRipetibile.maxEmissioni = mird.objectValue;
            }

            /*** CAMBIAMENTO ENNESIMO A SEGUITO DI KS-6304 */
            if (mird.objectTypeId == this.miObjectTypesList.find(x => x.code == "PMNC").id) {
              this.switch.limitiEmissione = true;
              this.fieldModel.limitiEmissione.maxEmissioniCliente = mird.objectValue;
            }

            /*
            if(mird.objectTypeId == this.miObjectTypesList.find(x=>x.code == "PMCT").id){
              this.fieldModel.limitiEmissione.maxEmissioniClienteTransazioni = mird.objectValue;
            }
            */
          }
        }
      }







    }


    //leggere regole e ccumulatori





  }
  onTotalCouponNumberChange(value: number) {
    this.fieldModel.limitiEmissione.maxEmissioniTotali = value;
    /*  this.totalCouponNumberChange.emit(value); */
  }

  groupResults(res: any, fieldToGroup: string, fieldName: string, newFieldName: string): Array<any> {
    // Raggruppa i dati secondo il campo specificato
    return res.data.reduce((acc, curr) => {
      const key = curr[fieldToGroup]; // Utilizza il campo desiderato per il raggruppamento

      const existingGroup = acc.find(item => item[fieldToGroup] === key);
      if (existingGroup) {
        if (!existingGroup[newFieldName].includes(curr[fieldName])) {
          existingGroup[newFieldName].push(curr[fieldName]); // Aggiungi il valore all'array se non presente
        }
      } else {
        const newGroup = {
          [fieldToGroup]: key,
          [newFieldName]: [curr[fieldName]], // Inizializza l'array con il primo valore
        };
        // Copia tutti gli altri campi dell'oggetto originale nell'elemento raggruppato
        Object.keys(curr).forEach(field => {
          if (field !== fieldToGroup && field !== fieldName) {
            newGroup[field] = curr[field];
          }
        });
        acc.push(newGroup);
      }

      return acc;
    }, []);


  }
  onChangeSoloBarcode(switchValue: boolean) {

    this.switch.soloBarcode = switchValue;

    //gestisco solo articolo coupon perchè disabilitato e required o meno, a seconda del valore dello switch.
    //gli altri campi non li gestisco perchè sono renderizzati o non renderizzati
    if (switchValue == true) {
      if (this.articoloCouponComponent) {
        this.articoloCouponComponent.disabled = true;
        this.articoloCouponComponent.required = false;
      }
    }
    else {
      if (this.articoloCouponComponent) {
        this.articoloCouponComponent.disabled = this.readOnly ? this.readOnly : this.articoloCouponComponent.fieldSchema.disabled;
        this.articoloCouponComponent.required = true;
      }
    }

    this.fieldModel.articoloCoupon.articolo = null;
    this.fieldModel.articoloCoupon.barcode = null;
    this.fieldModel.articoloCoupon.barcode = null;
  }

  onChangeSoloBarcodeAttivatore(switchValue: boolean) {

    this.switch.soloBarcodeAttivatore = switchValue;

    if (switchValue == true) {
      if (this.articoloCouponAttivatoreComponent) {
        this.articoloCouponAttivatoreComponent.disabled = true;
        this.articoloCouponAttivatoreComponent.required = false;
      }
    }
    else {
      if (this.articoloCouponAttivatoreComponent) {
        this.articoloCouponAttivatoreComponent.disabled = this.readOnly ? this.readOnly : this.articoloCouponAttivatoreComponent.fieldSchema.disabled;
        this.articoloCouponAttivatoreComponent.required = true;
      }
    }
    this.fieldModel.articoloCouponAttivatore.articolo = null;
    this.fieldModel.articoloCouponAttivatore.barcode = null;
    this.fieldModel.barcodeManualCouponAttivatore = null;
  }
  resetCouponRipetibileEmissione() {
     this.fieldModel.couponRipetibile.maxEmissioni = null;
    this.fieldModel.couponRipetibile.sogliaRiemissione = null; 
  }
  resetGestioneAccumulatoriEmissione() {
//non resettare semplicemente non creare regola
   /*  this.fieldModel.gestioneAccumulatori.accumulatoriDaUtilizzare = [];
    this.fieldModel.gestioneAccumulatori.regoleAvanzate = []; */
  }
  resetEmissioneBarcodeAttivatore() {
    this.fieldModel.articoloCouponAttivatore.articolo = null;
    this.fieldModel.articoloCouponAttivatore.barcode = null;
    this.fieldModel.barcodeManualCouponAttivatore = null;
    this.switch.soloBarcodeAttivatore = false;
  }
  resetLimitiEmissione() {
    this.fieldModel.limitiEmissione.maxEmissioniTotali = null;
    this.fieldModel.limitiEmissione.maxTransazioniCliente = null;
    this.fieldModel.limitiEmissione.maxEmissioniCliente = null;
  }
  onChangeCouponRipetibileEmissione(switchValue: boolean) {
    this.resetCouponRipetibileEmissione();

    if (switchValue == true) {
      this.messageInstanceObject.couponType = this.srvCampaign3.couponType.RIPETIBILE;
    }
    else {
      this.messageInstanceObject.couponType = this.srvCampaign3.couponType.SINGOLO;
    }
    this.messageInstanceObjectChange.emit(this.messageInstanceObject);
  }
  onChangeGestioneAccumulatoriEmissione(switchValue: boolean) {
    this.resetGestioneAccumulatoriEmissione();
  }
  onChangeEmissioneBarcodeAttivatore(switchValue: boolean) {
    this.resetEmissioneBarcodeAttivatore();
  }
  onChangeLimitiEmissione(switchValue: boolean) {


    if (switchValue == true) {
      if (this.messageInstanceObject.targetLoyaltyClass != "LOY" && this.messageInstanceObject.targetLoyaltyClass != null) {
        this.srvMessage.add({
          severity: 'error',
          summary: 'Error',
          detail: this.translateService.instant('campaign.emission_limits_non_loyalty_customers'),
          life: 5000
        });


        this.resetLimitiEmissione();
        var self = this;
        setTimeout(function () {
          self.switch.limitiEmissione = false;
        }, 100)
      }
    }

    if (!this.readOnly) {
      this.resetLimitiEmissione();
    }

  }
  onClickAddAccumulatori() {
    /*     this.fieldModel.gestioneAccumulatori.regoleAvanzate = []; */
    this.resetSelectedAcmRows();
    this.show.modalAcmList = true;
  }
  onClickAddAccumulatoriForRules() {
    /*     this.fieldModel.gestioneAccumulatori.regoleAvanzate = []; */
    this.resetSelectedAcmRowsForRules();
    this.show.modalAcmListForRules = true;
  }
  onClickSearchArticolo() {
    if (!this.switch.soloBarcode && !this.readOnly) {
      this.fieldModel.articoloCoupon.articolo = null;
      this.fieldModel.articoloCoupon.barcode = null;
      this.show.modalProductList = true;
    }
  }
  onClickSearchArticoloAttivatore() {
    if (!this.switch.soloBarcodeAttivatore && !this.readOnly) {
      this.fieldModel.articoloCouponAttivatore.articolo = null;
      this.fieldModel.articoloCouponAttivatore.barcode = null;
      this.show.modalProductListAttivatore = true;
    }
  }
  onAcmSelected(listAcm: Array<any>) {
    if (listAcm) {
      for (let acm of listAcm) {
        if (this.fieldModel.gestioneAccumulatori.accumulatoriDaUtilizzare.findIndex(x => x.id == acm.id) == -1) {
          acm["c3AcmValue"] = null;
          acm["c3AcmOperation"] = null;
          //TODO valorizzare la reason
          acm["c3AcmReason"] = null;
        }
      }
      this.fieldModel.gestioneAccumulatori.accumulatoriDaUtilizzare = Object.assign([], listAcm);
    }
    else {
      //caso annulla;
      this.show.modalAcmList = false;
    }

    this.show.modalAcmList = false;

  }
/* onAcmSelectedForRules(listAcm: Array<any>) {
  if (listAcm && listAcm.length > 0) {
    const previousList = this.fieldModel.gestioneAccumulatori.regoleAvanzate || [];

    // Crea una mappa veloce dei precedenti per lookup
    const previousMap = new Map(previousList.map(item => [item.id, item]));

    listAcm.forEach(acm => {
      const existing = previousMap.get(acm.id);

      const newAcm = { ...acm };

      newAcm.c3AcmRuleOperator = (existing && typeof existing.c3AcmRuleOperator !== 'undefined')
        ? existing.c3AcmRuleOperator
        : (typeof acm.c3AcmRuleOperator !== 'undefined' ? acm.c3AcmRuleOperator : null);

      newAcm.c3AcmRuleValue = (existing && typeof existing.c3AcmRuleValue !== 'undefined')
        ? existing.c3AcmRuleValue
        : (typeof acm.c3AcmRuleValue !== 'undefined' ? acm.c3AcmRuleValue : null);

      // Aggiorna la mappa
      previousMap.set(acm.id, newAcm);
    });

    // Ricostruisci la lista aggiornata
    this.fieldModel.gestioneAccumulatori.regoleAvanzate = Array.from(previousMap.values());
  }

  // Chiudi il modal
  this.show.modalAcmListForRules = false;
} */

onAcmSelectedForRules(listAcm: Array<any>) {
  if (listAcm && listAcm.length > 0) {
    const previousList = this.fieldModel.gestioneAccumulatori.regoleAvanzate || [];

    listAcm.forEach(acm => {
      const newAcm = { ...acm };

      // opzionalmente copia da ultimo esistente (non per chiave unica ma per "valore predefinito")
      const lastSame = [...previousList].reverse().find(x => x.id === acm.id);

      newAcm.c3AcmRuleOperator = (lastSame && typeof lastSame.c3AcmRuleOperator !== 'undefined')
        ? lastSame.c3AcmRuleOperator
        : (typeof acm.c3AcmRuleOperator !== 'undefined' ? acm.c3AcmRuleOperator : null);

      newAcm.c3AcmRuleValue = (lastSame && typeof lastSame.c3AcmRuleValue !== 'undefined')
        ? lastSame.c3AcmRuleValue
        : (typeof acm.c3AcmRuleValue !== 'undefined' ? acm.c3AcmRuleValue : null);

      // Aggiungilo senza controllare duplicati
      previousList.push(newAcm);
    });

    this.fieldModel.gestioneAccumulatori.regoleAvanzate = previousList;
  }

  this.show.modalAcmListForRules = false;
}




  resetSelectedAcmRows() {
    for (let acm of this.listAccumulatorModelEmission) {
      acm["rowSelected"] = false;
    }
    for (let acm of this.fieldModel.gestioneAccumulatori.accumulatoriDaUtilizzare) {
      this.listAccumulatorModelEmission.find(x => x.id == acm.id)["rowSelected"] = true;
    }
  }
  resetSelectedAcmRowsForRules() {
    for (let acm of this.listAccumulatorModelEmissionForRules) {
      acm["rowSelected"] = false;
    }
    //riattivarlo se voglio vedere quelli che ho già selezionato
  /*   for (let acm of this.fieldModel.gestioneAccumulatori.regoleAvanzate) {
      this.listAccumulatorModelEmissionForRules.find(x => x.id == acm.id)["rowSelected"] = true;
    } */
  }
  onOptionArticoloDropdownChanged(options) {
    /*
     * evento che si verifica perchè nonostante si assegnino dei valori alle options della combo articolo e si assegna un model
     * (all'interno del metodo loadEmissionModel())
     * la risposta alla chiamata del FormFieldsComponent che va a prendere le options via server arriva dopo e riassegna nuovamente le options, invalidando quindi l'assegnazione appena fatta da loadEmissionModel (problema object object).
     * C'è bisogno quindi di ascoltare quell'evento e comportarsi di conseguenza
     */
    if (this.ui_mode == this.srvCampaign3.ui_modes.EDIT) {
      if (this.fieldModel.articoloCoupon && this.fieldModel.articoloCoupon.articolo) {
        this.articoloCouponComponent.options = Object.assign([], [this.fieldModel.articoloCoupon.articolo]);
        this.articoloCouponComponent.fieldModel = Object.assign({}, this.fieldModel.articoloCoupon.articolo);
      }
    }
  }
  onOptionArticoloAttivatoreDropdownChanged(options) {
    /*
     * evento che si verifica perchè nonostante si assegnino dei valori alle options della combo articolo e si assegna un model
     * (all'interno del metodo loadEmissionModel())
     * la risposta alla chiamata del FormFieldsComponent che va a prendere le options via server arriva dopo e riassegna nuovamente le options, invalidando quindi l'assegnazione appena fatta da loadEmissionModel (problema object object).
     * C'è bisogno quindi di ascoltare quell'evento e comportarsi di conseguenza
     */
    if (this.ui_mode == this.srvCampaign3.ui_modes.EDIT) {
      if (this.fieldModel.articoloCouponAttivatore && this.fieldModel.articoloCouponAttivatore.articolo) {
        this.articoloCouponAttivatoreComponent.options = Object.assign([], [this.fieldModel.articoloCouponAttivatore.articolo]);
        this.articoloCouponAttivatoreComponent.fieldModel = Object.assign({}, this.fieldModel.articoloCouponAttivatore.articolo);
      }
    }
  }
  onChangeArticoloCoupon(articolo: ProductItemComplete) {
    this.comboBarcodes = [];
    if (articolo && articolo.barcodes && articolo.barcodes.length > 0) {
      for (let barcode of articolo.barcodes) {
        this.comboBarcodes.push({ id: barcode, barcode: barcode });
      }
    }

    this.comboBarcodesComponent.fieldModel = null;
    this.comboBarcodesComponent.options = this.comboBarcodes;

    if (this.comboBarcodes.length == 1) {
      this.fieldModel.articoloCoupon.barcode = this.comboBarcodes[0];
    }
    else {
      this.fieldModel.articoloCoupon.barcode = null;
    }

  }
  onProductSelected(articolo: any) {
    if (articolo) {
      this.articoloCouponComponent.options = [articolo];

      this.fieldModel.articoloCoupon.articolo = articolo;

      this.comboBarcodes = [];
      if (articolo && articolo.barcode) {
        this.comboBarcodes.push({ id: articolo.barcode, barcode: articolo.barcode });
      }

      this.comboBarcodesComponent.options = this.comboBarcodes;
      this.fieldModel.articoloCoupon.barcode = { id: articolo.barcode, barcode: articolo.barcode };
      this.comboBarcodesComponent.fieldModel = { id: articolo.barcode, barcode: articolo.barcode };

      this.show.modalProductList = false;
    }
  }
  onChangeArticoloCouponAttivatore(articolo: ProductItemComplete) {

    this.comboBarcodesAttivatore = [];
    if (articolo && articolo.barcodes && articolo.barcodes.length > 0) {
      for (let barcode of articolo.barcodes) {
        this.comboBarcodesAttivatore.push({ id: barcode, barcode: barcode });
      }
    }

    this.comboBarcodesAttivatoreComponent.fieldModel = null;
    this.comboBarcodesAttivatoreComponent.options = this.comboBarcodesAttivatore;

    if (this.comboBarcodesAttivatore.length == 1) {
      this.fieldModel.articoloCouponAttivatore.barcode = this.comboBarcodesAttivatore[0];
    }
    else {
      this.fieldModel.articoloCouponAttivatore.barcode = null;
    }

  }
  onProductAttivatoreSelected(articolo: any) {
    if (articolo) {
      this.articoloCouponAttivatoreComponent.options = [articolo];
      this.fieldModel.articoloCouponAttivatore.articolo = articolo;

      this.comboBarcodesAttivatore = [];
      if (articolo && articolo.barcode) {
        this.comboBarcodesAttivatore.push({ id: articolo.barcode, barcode: articolo.barcode });
      }

      this.comboBarcodesAttivatoreComponent.options = this.comboBarcodesAttivatore;
      this.fieldModel.articoloCouponAttivatore.barcode = { id: articolo.barcode, barcode: articolo.barcode };
      this.comboBarcodesAttivatoreComponent.fieldModel = { id: articolo.barcode, barcode: articolo.barcode };

      this.show.modalProductListAttivatore = false;
    }
  }
  onChangedFilterArticolo(searchValue) {
    this.comboBarcodes = [];
    this.fieldModel.articoloCoupon.barcode = null;
    this.comboBarcodesComponent.fieldModel = null;
    this.comboBarcodesComponent.options = [];
  }
  onChangedFilterArticoloAttivatore(searchValue) {
    this.comboBarcodesAttivatore = [];
    this.fieldModel.articoloCouponAttivatore.barcode = null;
    this.comboBarcodesAttivatoreComponent.fieldModel = null;
    this.comboBarcodesAttivatoreComponent.options = [];
  }
  onDeleteAcmFromList(index: number) {

    this.listAccumulatorModelEmission.find(x => x.id == this.fieldModel.gestioneAccumulatori.accumulatoriDaUtilizzare[index].id).rowSelected = false;
    this.fieldModel.gestioneAccumulatori.accumulatoriDaUtilizzare.splice(index, 1);

    /*
     let tempACC = Object.assign(this.fieldModel.gestioneAccumulatori[index]);
      let rule_AC = this.messageInstanceObject.messageInstanceRule.find(x=>x.ruleTypeId == this.miRuleTypesList.find(x=>x.code == "AC").id);
      if(rule_AC){
        let index_TACM = rule_AC.messageInstanceRuleDetail.findIndex(x=>x.objectTypeId == this.miObjectTypesList.find(x=>x.code == "TACM").id && x.objectTypeId == tempACC.id);
        if(index_TACM>-1){
          rule_AC.messageInstanceRuleDetail.splice(index_TACM,1);
        }
        let index_JAAR = rule_AC.messageInstanceRuleDetail.findIndex(x=>x.objectTypeId == this.miObjectTypesList.find(x=>x.code == "JAAR").id);
      }
      */
  }


  onDeleteAcmFromRuleList(index: number) {

    this.listAccumulatorModelEmissionForRules.find(x => x.id == this.fieldModel.gestioneAccumulatori.regoleAvanzate[index].id).rowSelected = false;
    this.fieldModel.gestioneAccumulatori.regoleAvanzate.splice(index, 1);

    /*
     let tempACC = Object.assign(this.fieldModel.gestioneAccumulatori[index]);
      let rule_AC = this.messageInstanceObject.messageInstanceRule.find(x=>x.ruleTypeId == this.miRuleTypesList.find(x=>x.code == "AC").id);
      if(rule_AC){
        let index_TACM = rule_AC.messageInstanceRuleDetail.findIndex(x=>x.objectTypeId == this.miObjectTypesList.find(x=>x.code == "TACM").id && x.objectTypeId == tempACC.id);
        if(index_TACM>-1){
          rule_AC.messageInstanceRuleDetail.splice(index_TACM,1);
        }
        let index_JAAR = rule_AC.messageInstanceRuleDetail.findIndex(x=>x.objectTypeId == this.miObjectTypesList.find(x=>x.code == "JAAR").id);
      }
      */
  }

  onClickAddRegoleAvanzate() {
    if (this.fieldModel.gestioneAccumulatori.accumulatoriDaUtilizzare.length > 0 && this.fieldModel.gestioneAccumulatori.regoleAvanzate.length == 0) {
      let reg = new RegolaAvanzata();
      reg.id = this.fieldModel.gestioneAccumulatori.regoleAvanzate.length + 1;
      reg.value = null;
      this.fieldModel.gestioneAccumulatori.regoleAvanzate.push(reg);
    }
  }
  onDeleteRegolaFromList(index: number) {
    this.fieldModel.gestioneAccumulatori.regoleAvanzate.splice(index, 1);
  }
  onClickAnnulla_ModalArticoli() {
    this.show.modalProductList = false;
  }
  createRules() {

    this.CV_rules = [];
    this.BC_rules = [];
    this.BA_rules = [];
    this.AC_rules = [];
    this.LM_rules = [];

    let ruleScopeEmission = this.srvCampaign3.ruleScopesEmissionFruition.EMISSION;

    //primi 4 campi;
    if (this.fieldModel.tipoSogliaEmissione || this.fieldModel.sogliaEmissione || this.fieldModel.couponRipetibile.sogliaRiemissione
      //|| this.fieldModel.couponRipetibile.maxEmissioni
    ) {
      let ruleCV = new MessageInstanceRule();
      ruleCV.messageInstanceId = this.messageInstanceObject.id;
      ruleCV.ruleTypeId = this.miRuleTypesList.find(x => x.code == "CV").id;
      ruleCV.ruleType = "CV";
      ruleCV.messageInstanceRuleDetail = new Array<MessageInstanceRuleDetail>();
      ruleCV.ruleScope = ruleScopeEmission;

      if (this.fieldModel.tipoSogliaEmissione) {
        let CV_mird_1 = new MessageInstanceRuleDetail();
        CV_mird_1.objectTypeId = this.miObjectTypesList.find(x => x.code == "PTRT").id;
        CV_mird_1.objectTypeCode = "PTRT";
        CV_mird_1.objectValue = this.fieldModel.tipoSogliaEmissione.value;
        ruleCV.messageInstanceRuleDetail.push(CV_mird_1);
      }

      if (this.fieldModel.sogliaEmissione) {
        let CV_mird_2 = new MessageInstanceRuleDetail();
        CV_mird_2.objectTypeId = this.miObjectTypesList.find(x => x.code == "PTRE").id;
        CV_mird_2.objectTypeCode = "PTRE";
        CV_mird_2.objectValue = (Math.round(this.fieldModel.sogliaEmissione * 100)).toString();
        ruleCV.messageInstanceRuleDetail.push(CV_mird_2);
      }

      if (this.fieldModel.couponRipetibile.sogliaRiemissione) {
        let CV_mird_3 = new MessageInstanceRuleDetail();
        CV_mird_3.objectTypeId = this.miObjectTypesList.find(x => x.code == "PRTR").id;
        CV_mird_3.objectTypeCode = "PRTR";
        CV_mird_3.objectValue = (Math.round(this.fieldModel.couponRipetibile.sogliaRiemissione * 100)).toString();
        ruleCV.messageInstanceRuleDetail.push(CV_mird_3);
      }

      this.CV_rules.push(ruleCV);
    }

    // ACCUMULATORI
    let arrayMove: AccumulatorDetail_JACR_JAAR[] = [];
    let arrayCheck: AccumulatorDetail_JACR_JAAR[] = [];
    // --- POPOLA MOVE ---
    if (
      this.fieldModel.gestioneAccumulatori.accumulatoriDaUtilizzare &&
      this.fieldModel.gestioneAccumulatori.accumulatoriDaUtilizzare.length > 0 &&
      this.acm_operation &&
      this.acm_value
    ) {
      let arrayOp = this.acm_operation.toArray();
      let arrayVal = this.acm_value.toArray();

      for (let i = 0; i < this.fieldModel.gestioneAccumulatori.accumulatoriDaUtilizzare.length; i++) {
        if (
          arrayOp[i] &&
          arrayOp[i].fieldModel &&
          arrayVal[i] &&
          arrayVal[i].fieldModel
        ) {
          let move = new AccumulatorDetail_JACR_JAAR();
          move.acm_code = this.fieldModel.gestioneAccumulatori.accumulatoriDaUtilizzare[i].acm_code;
          move.acm_operation = arrayOp[i].fieldModel.value;
          move.acm_points = arrayVal[i].fieldModel;
          move.acm_id = this.fieldModel.gestioneAccumulatori.accumulatoriDaUtilizzare[i].id;
          move.acm_reason_code = this.fieldModel.gestioneAccumulatori.accumulatoriDaUtilizzare[i].c3AcmReason.value;
          move.koncentro= this.selectedMode;
          move.operator =  this.useAnd ? 'AND' : 'OR',
          arrayMove.push(move);
        }
      }
    }

    // --- POPOLA CHECK ---
    if (
      this.fieldModel.gestioneAccumulatori.regoleAvanzate &&
      this.fieldModel.gestioneAccumulatori.regoleAvanzate.length > 0 &&
      this.acm_rule_operator &&
      this.acm_rule_value
    ) {
      let arrayOp = this.acm_rule_operator.toArray();
      let arrayVal = this.acm_rule_value.toArray();

      for (let i = 0; i < this.fieldModel.gestioneAccumulatori.regoleAvanzate.length; i++) {
        if (
          arrayOp[i] &&
          arrayOp[i].fieldModel &&
          arrayVal[i] &&
          arrayVal[i].fieldModel
        ) {
          let check = new AccumulatorDetail_JACR_JAAR();
          check.acm_code = this.fieldModel.gestioneAccumulatori.regoleAvanzate[i].acm_code;
          check.acm_operation = arrayOp[i].fieldModel.value;
          check.acm_points = arrayVal[i].fieldModel;
          check.acm_id = this.fieldModel.gestioneAccumulatori.regoleAvanzate[i].id;
          check.acm_reason_code = undefined;
          check.koncentro= true;
          check.operator =  this.useAnd ? 'AND' : 'OR',
          arrayCheck.push(check);
        }
      }
    }


    // --- CREA LA REGOLA SOLO SE ALMENO UN DETTAGLIO ESISTE ---
    if (arrayMove.length > 0 || arrayCheck.length > 0) {
      let ruleAC = new MessageInstanceRule();
      ruleAC.messageInstanceId = this.messageInstanceObject.id;
      ruleAC.ruleTypeId = this.miRuleTypesList.find(x => x.code == "AC").id;
      ruleAC.ruleType = "AC";
      ruleAC.ruleScope = ruleScopeEmission;
      ruleAC.messageInstanceRuleDetail = [];

      if (arrayMove.length > 0) {
        let rdMove = new MessageInstanceRuleDetail();
        rdMove.objectTypeId = this.miObjectTypesList.find(x => x.code == "JAAR").id;
        rdMove.objectTypeCode = "JAAR";
        rdMove.objectJson = new AccumulatorDetail_JAAR();
        rdMove.objectJson.move = arrayMove;
        ruleAC.messageInstanceRuleDetail.push(rdMove);
      }

      if (arrayCheck.length > 0) {
        let rdCheck = new MessageInstanceRuleDetail();
        rdCheck.objectTypeId = this.miObjectTypesList.find(x => x.code == "JACR").id;
        rdCheck.objectTypeCode = "JACR";
        rdCheck.objectJson = new AccumulatorDetail_JACR();
        rdCheck.objectJson.check = arrayCheck;
        ruleAC.messageInstanceRuleDetail.push(rdCheck);
      }

      this.AC_rules.push(ruleAC);
    }

    console.log(this.AC_rules);




    //articolo e barcode

    if ((this.fieldModel.articoloCoupon.articolo && this.fieldModel.articoloCoupon.barcode) || this.fieldModel.barcodeManualCoupon) {
      //caso barcode scelto da tendina
      let ruleBC = new MessageInstanceRule();
      ruleBC.messageInstanceId = this.messageInstanceObject.id;
      ruleBC.ruleTypeId = this.miRuleTypesList.find(x => x.code == "BC").id;
      ruleBC.ruleType = "BC";
      ruleBC.messageInstanceRuleDetail = new Array<MessageInstanceRuleDetail>();
      ruleBC.ruleScope = ruleScopeEmission;

      if (this.fieldModel.articoloCoupon.articolo && this.fieldModel.articoloCoupon.barcode) {
        let rd = new MessageInstanceRuleDetail();
        rd.objectTypeId = this.miObjectTypesList.find(x => x.code == "TBCD").id;
        rd.objectTypeCode = "TBCD";
        rd.objectId = this.fieldModel.articoloCoupon.articolo.id;
        rd.objectValue = this.fieldModel.articoloCoupon.barcode.id;
        ruleBC.messageInstanceRuleDetail.push(rd);
      }
      else if (this.fieldModel.barcodeManualCoupon) {
        //caso barcode manuale
        let rd = new MessageInstanceRuleDetail();
        rd.objectTypeId = this.miObjectTypesList.find(x => x.code == "PBCD").id;
        rd.objectTypeCode = "PBCD";
        rd.objectValue = this.fieldModel.barcodeManualCoupon;
        ruleBC.messageInstanceRuleDetail.push(rd);
      }

      this.BC_rules.push(ruleBC);
    }
    if ((this.fieldModel.articoloCouponAttivatore.articolo && this.fieldModel.articoloCouponAttivatore.barcode) || this.fieldModel.barcodeManualCouponAttivatore) {
      //articolo attivatore e barcode attivatore
      let ruleBA = new MessageInstanceRule();
      ruleBA.messageInstanceId = this.messageInstanceObject.id;
      ruleBA.ruleTypeId = this.miRuleTypesList.find(x => x.code == "BA").id;
      ruleBA.ruleType = "BA";
      ruleBA.messageInstanceRuleDetail = new Array<MessageInstanceRuleDetail>();
      ruleBA.ruleScope = ruleScopeEmission;

      if (this.fieldModel.articoloCouponAttivatore.articolo && this.fieldModel.articoloCouponAttivatore.barcode) {
        let rd = new MessageInstanceRuleDetail();
        rd.objectTypeId = this.miObjectTypesList.find(x => x.code == "TBCD").id;
        rd.objectTypeCode = "TBCD";
        rd.objectId = this.fieldModel.articoloCouponAttivatore.articolo.id;
        rd.objectValue = this.fieldModel.articoloCouponAttivatore.articolo.host_code;
        ruleBA.messageInstanceRuleDetail.push(rd);
      }
      else if (this.fieldModel.barcodeManualCouponAttivatore) {
        let rd = new MessageInstanceRuleDetail();
        rd.objectTypeId = this.miObjectTypesList.find(x => x.code == "PBCD").id;
        rd.objectTypeCode = "PBCD";
        rd.objectValue = this.fieldModel.barcodeManualCouponAttivatore;
        ruleBA.messageInstanceRuleDetail.push(rd);
      }

      this.BA_rules.push(ruleBA);
    }

    //limiti di emissione
    if (this.fieldModel.limitiEmissione.maxTransazioniCliente || this.fieldModel.couponRipetibile.maxEmissioni
      //|| this.fieldModel.limitiEmissione.maxEmissioniClienteTransazioni
    ) {

      let ruleLM = new MessageInstanceRule();
      ruleLM.messageInstanceId = this.messageInstanceObject.id;
      ruleLM.ruleTypeId = this.miRuleTypesList.find(x => x.code == "LM").id;
      ruleLM.ruleType = "LM";
      ruleLM.messageInstanceRuleDetail = new Array<MessageInstanceRuleDetail>();
      ruleLM.ruleScope = ruleScopeEmission;

      if (this.fieldModel.couponRipetibile.maxEmissioni) {
        let rd = new MessageInstanceRuleDetail();
        rd.objectTypeId = this.miObjectTypesList.find(x => x.code == "PMCT").id;
        rd.objectTypeCode = "PMCT";
        rd.objectValue = this.fieldModel.couponRipetibile.maxEmissioni;
        ruleLM.messageInstanceRuleDetail.push(rd);
      }


      if (this.switch.limitiEmissione) {
        /*** MODIFICA KS-6304: non è più una regola, ma una proprietà dell'oggettone della messageInstance */
        /*
            if(this.fieldModel.limitiEmissione.maxEmissioniTotali){



              let rd = new MessageInstanceRuleDetail();
              rd.objectTypeId = this.miObjectTypesList.find(x=>x.code == "PMNC").id;
              rd.objectTypeCode = "PMNC";
              rd.objectValue = this.fieldModel.limitiEmissione.maxEmissioniTotali;
              ruleLM.messageInstanceRuleDetail.push(rd);

            }
      */
        if (this.fieldModel.limitiEmissione.maxTransazioniCliente) {
          let rd = new MessageInstanceRuleDetail();
          rd.objectTypeId = this.miObjectTypesList.find(x => x.code == "PMTC").id;
          rd.objectTypeCode = "PMTC";
          rd.objectValue = this.fieldModel.limitiEmissione.maxTransazioniCliente;
          ruleLM.messageInstanceRuleDetail.push(rd);
        }


        /*** CAMBIAMENTO A SEGUITO DI CALL 02/04/2024 (vedi commenti issue KS-5417 e KS-5418) ***/
        /*
        if(this.fieldModel.limitiEmissione.maxEmissioniClienteTransazioni){
          let rd = new MessageInstanceRuleDetail();
          rd.objectTypeId = this.miObjectTypesList.find(x=>x.code == "PMCT").id;
          rd.objectTypeCode = "PMCT";
          rd.objectValue = this.fieldModel.limitiEmissione.maxEmissioniClienteTransazioni;
          ruleLM.messageInstanceRuleDetail.push(rd);
        }
        */

        /*** CAMBIAMENTO ENNESIMO A SEGUITO DI KS-6304 ***/
        if (this.fieldModel.limitiEmissione.maxEmissioniCliente) {
          let rd = new MessageInstanceRuleDetail();
          rd.objectTypeId = this.miObjectTypesList.find(x => x.code == "PMNC").id;
          rd.objectTypeCode = "PMNC";
          rd.objectValue = this.fieldModel.limitiEmissione.maxEmissioniCliente;
          ruleLM.messageInstanceRuleDetail.push(rd);
        }
      }
      this.LM_rules.push(ruleLM);
    }
  }







  checkLimitiEmissioneErrors(): boolean {
    let res = false
    if (this.switch.couponRipetibile == true && this.switch.limitiEmissione == true) {

      /*
      "- Numero massimo emissioni totali (total_coupon_number) ≥ '- Numero massimo emissioni per cliente (LM/PMNC/emission) se valorizzato
      */
      if (this.fieldModel.limitiEmissione.maxEmissioniTotali && this.fieldModel.limitiEmissione.maxEmissioniCliente && (+this.fieldModel.limitiEmissione.maxEmissioniTotali < +this.fieldModel.limitiEmissione.maxEmissioniCliente)) {

        this.srvMessage.add({
          severity: 'error',
          summary: 'Error',
          detail: this.translateService.instant('campaign.max_total_emissions_less_than_per_customer'),
          life: 5000
        });


        if (this.maxEmissioniTotali) this.maxEmissioniTotali.valid = false;
        if (this.maxEmissioniClienteTransazioni) this.maxEmissioniClienteTransazioni.valid = false;
        return true;
      }
      /*
     "- Numero massimo emissioni totali (total_coupon_number) ≥ '- Numero massimo emissioni per cliente (LM/PMNC/emission) se valorizzato
     */
      if (this.fieldModel.limitiEmissione.maxEmissioniTotali && this.fieldModel.couponRipetibile.maxEmissioni && (+this.fieldModel.limitiEmissione.maxEmissioniTotali < +this.fieldModel.couponRipetibile.maxEmissioni)) {
        if (this.maxEmissioniTotali) this.maxEmissioniTotali.valid = false;
        if (this.maxEmissioni) this.maxEmissioni.valid = false;

        this.srvMessage.add({
          severity: 'error',
          summary: 'Error',
          detail: this.translateService.instant('campaign.max_total_emissions_less_than_repeatable'),
          life: 5000
        });


        return true;
      }
      /*
     "- Numero massimo emissioni totali (total_coupon_number) ≥ '- Numero massimo transazioni emittenti per cliente (LM/PMTC/emission) se valorizzato"
     */
      if (this.fieldModel.limitiEmissione.maxEmissioniTotali && this.fieldModel.limitiEmissione.maxTransazioniCliente && (+this.fieldModel.limitiEmissione.maxEmissioniTotali < +this.fieldModel.limitiEmissione.maxTransazioniCliente)) {
        if (this.maxEmissioniTotali) this.maxEmissioniTotali.valid = false;
        if (this.maxTransazioniCliente) this.maxTransazioniCliente.valid = false;
        this.srvMessage.add({
          severity: 'error',
          summary: 'Error',
          detail: this.translateService.instant('campaign.max_total_emissions_less_than_per_customer'),
          life: 5000
        });


        return true;
      }

      /*
      "- Numero massimo transazioni emittenti per cliente (LM/PMTC/emission) ≤ - Numero massimo emissioni totali (total_coupon_number)
      (già implementato sopra, secondo punto)

      "- Numero massimo transazioni emittenti per cliente (LM/PMTC/emission) ≤ - Numero massimo emissioni per cliente (LM/PMNC/emission) "
      (già implementato sopra, primo punto)
      */

      /* Numero massimo emissioni per cliente (LM/PMNC/emission) ≤ '- Numero massimo emissioni totali (total_coupon_number)
      (già implementato sopra, primo punto) */


      /* - Numero massimo emissioni per cliente (LM/PMNC/emission) ≥ '- Numero massimo transazioni emittenti per cliente (LM/PMTC/emission) se valorizzato */
      if (this.fieldModel.limitiEmissione.maxEmissioniCliente && this.fieldModel.limitiEmissione.maxTransazioniCliente && (+this.fieldModel.limitiEmissione.maxEmissioniCliente < +this.fieldModel.limitiEmissione.maxTransazioniCliente)) {
        if (this.maxEmissioniClienteTransazioni) this.maxEmissioniClienteTransazioni.valid = false;
        if (this.maxTransazioniCliente) this.maxTransazioniCliente.valid = false;

        this.srvMessage.add({
          severity: 'error',
          summary: 'Error',
          detail: this.translateService.instant('campaign.max_emissions_per_customer_less_than_transactions'),
          life: 5000
        });


        return true;
      }
    }
    return res;
  }
  checkBarcodeAvailability(barcode: string): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      let payload = new CalculateFruitionDateRequest();
      payload.flg_rolling = this.messageInstanceObject.flgRolling;
      payload.start_fruition_date = this.messageInstanceObject.startFruitionDate;
      payload.end_fruition_date = this.messageInstanceObject.endFruitionDate;
      payload.coupon_validity_date_start_mode = this.messageInstanceObject.couponValidityDateStartMode;
      payload.coupon_validity_date_start = this.messageInstanceObject.couponValidityDateStart;
      payload.coupon_validity_start_offset_day = this.messageInstanceObject.couponValidityStartOffsetDay;
      payload.coupon_validity_start_week_day = this.messageInstanceObject.couponValidityStartWeekDay;
      payload.coupon_validity_date_end_mode = this.messageInstanceObject.couponValidityDateEndMode;
      payload.coupon_validity_date_end = this.messageInstanceObject.couponValidityDateEnd;
      payload.coupon_validity_end_offset_day = this.messageInstanceObject.couponValidityEndOffsetDay;
      payload.coupon_validity_end_week_day = this.messageInstanceObject.couponValidityEndWeekDay;
      payload.id = this.messageInstanceObject.id;
      payload.end_emission_date = this.messageInstanceObject.endEmissionDate;

      var self = this;
      this.srvCampaign3.calculateFruitionDate(payload).subscribe(res => {

        if (res /*&& res.fruition_date_start && res.fruition_date_end KS-6817*/) {

          let checkBarcode = {
            start_emission_date: this.messageInstanceObject.startEmissionDate,
            end_emission_date: this.messageInstanceObject.endEmissionDate,
            start_fruition_date: res.fruition_date_start,
            end_fruition_date: res.fruition_date_end,
            barcode: barcode,
            message_instance_id: this.messageInstanceObject.id
          };

          self.srvCampaign3.checkBarcodeAvailability(checkBarcode).subscribe(res => {
            resolve(res); // Risolve la Promise con il risultato della chiamata
          }, error => {
            reject(error); // Rejette la Promise in caso di errore
          });

        }

      })


      /*

        this.srvCampaign3.checkBarcodeAvailability(this.campaignInfo.id, barcode, this.messageInstanceObject.id, checkBarcode).subscribe(res => {
            resolve(res); // Risolve la Promise con il risultato della chiamata
        }, error => {
            reject(error); // Rejette la Promise in caso di errore
        });
        */
    });
  }
  checkNotSomeBarcode(barcode1: string, barcode2: string): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      if (barcode1 && barcode2 && barcode1 != barcode2) {
        resolve(true); // Risolve la Promise con il risultato della chiamata
      }
      else {
        resolve(false); // Risolve la Promise con il risultato della chiamata
      }

    });
  }
onOperationSelected(event: { label: string; value: string }) {
  console.log('Ricevuto:', event); // Questo non deve essere undefined
  console.log(this.reasonItems);
}

  onChangeTipoSoglia(value: TipoSogliaEmissioneDropdown) {
    if (value) {
      this.fieldModel.tipoSogliaEmissione = value;
      //aggiunto controllo su visibilità in quanto in cds è nascosto
      if (value.value && this.sogliaEmissione && this.sogliaEmissione.visible) {
        this.sogliaEmissione.required = true;
      }
      else {
        if (this.sogliaEmissione) {
          this.sogliaEmissione.required = false;
        }
      }
    }
    else {
      if (this.sogliaEmissione) {
        this.sogliaEmissione.required = false;
      }
    }
  }
  performValidationEmissionConditions(): Promise<boolean> {
    if (
      (!this.fieldModel.articoloCoupon.articolo || !this.fieldModel.articoloCoupon.barcode) &&
      !this.fieldModel.barcodeManualCoupon
    ) {
      this.show.mandatoryProduct = true;
      return;
    }
    //check su limiti emissione
    let limitiError = this.checkLimitiEmissioneErrors();
    if (limitiError == true) return;


    // Creare un array di Promise per le chiamate asincrone
    const asyncTasks: Promise<boolean>[] = [];
    let barcodeToCheck = "";
    let barcodeToCheck2 = "";

    //Chiamata asincrona per il barcodeCoupon
    if (this.fieldModel.articoloCoupon.articolo && this.fieldModel.articoloCoupon.barcode) {
      barcodeToCheck = this.fieldModel.articoloCoupon.barcode.id;
      asyncTasks.push(this.checkBarcodeAvailability(barcodeToCheck));
    }
    else if (this.fieldModel.barcodeManualCoupon) {
      barcodeToCheck = this.fieldModel.barcodeManualCoupon;
      asyncTasks.push(this.checkBarcodeAvailability(barcodeToCheck));
    }
    if (barcodeToCheck != "" && barcodeToCheck2 != "") {
      asyncTasks.push(this.checkNotSomeBarcode(barcodeToCheck, barcodeToCheck2));
    }

    return Promise.all(asyncTasks).then(results => {

      // Se almeno uno dei risultati è true, o entrambi, chiamare performValidationAllFields e restituire il risultato
      if (results.some(result => result === false)) {
        if (results && results[0] == false) {
          this.barcodeAvailable.articolo = false;
        }
        if (results && results[1] == false) {
          this.barcodeAvailable.articoloAttivatore = false;
        }
        if (results && results[2] == false) {
          this.barcodeAvailable.articolo = false;
          this.barcodeAvailable.articoloAttivatore = false;
        }

        this.confirmationService.confirm({
          header: this.translateService.instant('common.warning'),
          message: this.translateService.instant('campaign.checkBarcodeStop'),
          acceptLabel: 'Ok',
          rejectVisible: false
        });
        return false; // Ritorna false se entrambe le chiamate sono false

      } else {
        this.barcodeAvailable.articolo = true;
        this.barcodeAvailable.articoloAttivatore = true;
        return this.performValidationAllFields();
      }
    }).catch(error => {
      // Se c'è un errore durante una delle chiamate asincrone, gestirlo qui
      console.error("Error occurred during async operations:", error);
      return false; // Ritorna false in caso di errore
    });
  }
  performValidationAllFields(): boolean {
    //primi quattro campi
    if (this.tipoSogliaEmissione) this.tipoSogliaEmissione.performValidation();
    if (this.sogliaEmissione) this.sogliaEmissione.performValidation();

    if (this.switch.couponRipetibile) {
      if (this.sogliaRiemissione) this.sogliaRiemissione.performValidation();
      if (this.maxEmissioni) this.maxEmissioni.performValidation();
    }

    /*    if (this.switch.gestioneAccumulatori && this.fieldModel.gestioneAccumulatori.accumulatoriDaUtilizzare && this.fieldModel.gestioneAccumulatori.accumulatoriDaUtilizzare.length > 0) { */

    //accumulatori
    /*      if (this.acm_operation) {
   
           let arrayOp = this.acm_operation.toArray();
           let arrayVal = this.acm_value.toArray();
   
           for (let op of arrayOp) {
             op.performValidation();
           }
           for (let val of arrayVal) {
             val.performValidation();
           }
         }
       }
    */


    //barcode
    if (this.articoloCouponComponent) {
      if (this.articoloCouponComponent.disabled == false && this.comboBarcodesComponent) {
        this.articoloCouponComponent.performValidation();
        if (this.comboBarcodesComponent) this.comboBarcodesComponent.performValidation();
        if (this.soloBarcode) this.soloBarcode.performValidation();
      }
      else if (this.articoloCouponComponent.disabled == true) {
        if (this.soloBarcodeText) this.soloBarcodeText.performValidation();
      }
    }

    //barcode attivatore
    if (this.switch.emissioneBarcodeAttivatore && this.articoloCouponAttivatoreComponent) {
      if (this.articoloCouponAttivatoreComponent.disabled == false && this.comboBarcodesAttivatoreComponent) {
        this.articoloCouponAttivatoreComponent.performValidation();
        if (this.comboBarcodesAttivatoreComponent) this.comboBarcodesAttivatoreComponent.performValidation();
        if (this.soloBarcodeAttivatore) this.soloBarcodeAttivatore.performValidation();
      }
      else if (this.articoloCouponAttivatoreComponent.disabled == true) {
        if (this.soloBarcodeAttivatoreText) this.soloBarcodeAttivatoreText.performValidation();
      }
    }

    //limiti di emissione
    if (this.switch.limitiEmissione) {
      if (this.maxEmissioniTotali) this.maxEmissioniTotali.performValidation();
      if (this.maxTransazioniCliente) this.maxTransazioniCliente.performValidation();
      if (this.maxEmissioniClienteTransazioni) this.maxEmissioniClienteTransazioni.performValidation();
    }

    let error = false;

    if (this.maxEmissioniClienteTransazioni && this.maxTransazioniCliente) {

      //Numero massimo transazioni emittenti per cliente (LM/PMTC/emission) ≤ - Numero massimo emissioni per cliente (LM/PMNC/emission)
      if (this.maxTransazioniCliente.fieldModel && this.maxEmissioniClienteTransazioni.fieldModel) {
        if (this.maxTransazioniCliente.fieldModel > this.maxEmissioniClienteTransazioni.fieldModel) {
          error = true;

          this.maxEmissioniClienteTransazioni.valid = false;
          this.maxTransazioniCliente.valid = false;

          this.srvMessage.add({
            severity: 'error',
            summary: 'Error', // Mantieni in inglese
            detail: this.translateService.instant('campaign.max_transactions_per_customer_less_than_emissions'),
            life: 5000
          });


        }
      }
    }
    if (this.maxEmissioniClienteTransazioni && this.maxEmissioni) {

      // Numero massimo emissioni per cliente per transazione (LM/PMCT/emission) ≤ Numero massimo emissioni per cliente (LM/PMNC/emission)
      if (this.maxEmissioni.fieldModel && this.maxEmissioniClienteTransazioni.fieldModel) {
        if (this.maxEmissioni.fieldModel > this.maxEmissioniClienteTransazioni.fieldModel) {
          error = true;

          this.maxEmissioniClienteTransazioni.valid = false;
          this.maxEmissioni.valid = false;

          this.srvMessage.add({
            severity: 'error',
            summary: 'Error', // Mantieni in inglese
            detail: this.translateService.instant('campaign.max_emissions_per_transaction_less_than_emissions'),
            life: 5000
          });


        }
      }
    }
    if (this.maxEmissioniClienteTransazioni && this.maxEmissioni && this.maxTransazioniCliente) {

      // Numero massimo emissioni per cliente per transazione (LM/PMCT/emission) ≥ (Numero massimo emissioni per cliente (LM/PMNC/emission) / Numero massimo transazioni emittenti per cliente (LM/PMTC))
      if (this.maxEmissioni.fieldModel && this.maxEmissioniClienteTransazioni.fieldModel && this.maxTransazioniCliente.fieldModel) {

        let fraction = this.maxEmissioniClienteTransazioni.fieldModel / this.maxTransazioniCliente.fieldModel

        if (this.maxEmissioni.fieldModel < fraction) {

          this.maxEmissioniClienteTransazioni.valid = false;
          this.maxEmissioni.valid = false;
          this.maxTransazioniCliente.valid = false;

          this.srvMessage.add({
            severity: 'error',
            summary: 'Error', // Mantieni in inglese
            detail: this.translateService.instant('campaign.max_emissions_per_transaction_ratio'),
            life: 5000
          });


        }
      }
    }

    if (
      (this.tipoSogliaEmissione && !this.tipoSogliaEmissione.valid) ||
      (this.sogliaEmissione && !this.sogliaEmissione.valid) ||
      (this.switch.couponRipetibile &&
        ((this.sogliaRiemissione && !this.sogliaRiemissione.valid) ||
          (this.maxEmissioni && !this.maxEmissioni.valid))) ||
      (this.articoloCouponComponent && !this.articoloCouponComponent.disabled && !this.articoloCouponComponent.valid) ||
      (this.articoloCouponComponent && !this.articoloCouponComponent.disabled && this.comboBarcodesComponent && !this.comboBarcodesComponent.valid) ||
      (this.articoloCouponComponent && this.articoloCouponComponent.disabled && this.soloBarcodeText && !this.soloBarcodeText.valid) ||
      (this.soloBarcode && !this.soloBarcode.valid) ||
      (this.articoloCouponAttivatoreComponent && !this.articoloCouponAttivatoreComponent.valid) ||
      (this.comboBarcodesAttivatoreComponent && !this.comboBarcodesAttivatoreComponent.valid) ||
      (this.soloBarcodeAttivatoreText && !this.soloBarcodeAttivatoreText.valid) ||
      (this.maxEmissioniTotali && !this.maxEmissioniTotali.valid) ||
      (this.maxTransazioniCliente && !this.maxTransazioniCliente.valid) ||
      (this.maxEmissioniClienteTransazioni && !this.maxEmissioniClienteTransazioni.valid) ||
      (this.acm_rule_operator && this.acm_rule_operator.length > 0 &&
        this.acm_rule_operator.some(op => { op.performValidation(); return !op.valid; })) ||
      (this.acm_rule_value && this.acm_rule_value.length > 0 &&
        this.acm_rule_value.some(val => { val.performValidation(); return !val.valid; })) ||
      (this.acm_operation && this.acm_operation.length > 0 &&
        this.acm_operation.some(op => { op.performValidation(); return !op.valid; })) ||
      (this.acm_value && this.acm_value.length > 0 &&
        this.acm_value.some(val => { val.performValidation(); return !val.valid; })) ||
      (this.acm_reaspm && this.acm_reaspm.length > 0 &&
        this.acm_reaspm.some(val => { val.performValidation(); return !val.valid; }))
    ) {
      error = true;
    }

    this.valid = (error == false) ? true : false;

    return this.valid;
  }



  validateAllOperators() {
    this.acm_rule_operator.forEach((operator: FormFields) => {
      operator.performValidation();
    });
  }




onReasonSelected(selectedReason: any, index: number): void {
  const accumulator = this.fieldModel.gestioneAccumulatori.accumulatoriDaUtilizzare[index];

  if (selectedReason) {
    const sign = selectedReason.sign;

    // Mappa da simbolo a operazione
    const operatorMap = {
      '+': 'ADD',
      '-': 'SUB'
    };

    const operationValue = operatorMap[sign];

    if (operationValue) {
      // Cerca l'opzione corrispondente
      const optionFound = this.formSchema.form.accumulatore_operazione.options.find(
        opt => opt.value === operationValue
      );

      if (optionFound) {
        // Imposta l'operatore sul modello
        accumulator.c3AcmOperation = {
          label: optionFound.label[this.authService.sessionHelper.selectedLanguage],
          value: optionFound.value
        };
      }
    }
  } else {
    // Reset se deselezionato
    accumulator.c3AcmOperation = null;
  }
}





}





// WEBPACK FOOTER //
// ./src/app/views/campaign-3/views/campaign-3-emission-conditions/campaign-3-emission-conditions.component.ts